import React from 'react';
import { Field } from 'react-final-form';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { RenderTextField as TextField } from '../../../../components/RenderTextField';
import FormSectionDescription from '../../../../components/FormSectionDescription';
import ExpansionPanelStyles from '../../../../components/ExpansionPanelStyles';

const styles = {
  ...ExpansionPanelStyles.compressed,
  formWrapper: {
    width: '100%',
    maxWidth: '1060px',
    borderRadius: '3px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
    backgroundColor: 'white',
  },
  textField: {
    width: '100%',
  },
};

const LanguageFields = ({ classes, index }) => {
  return (
    <div className={classes.formWrapper}>
      <ExpansionPanel elevation={2} defaultExpanded className={classes.panel}>
        <ExpansionPanelSummary className={classes.panelSummary} expandIcon={<ExpandMoreIcon/>}>
          <FormSectionDescription title="Short text"/>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.extendedDetails}>
          <Field component={TextField}
            className={classes.textField}
            multiline
            maxRows={10}
            variant="outlined"
            name={`universalConsentItemTranslations[${index}].shortText`}
            label="Short text (500 character limit)"/>
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <ExpansionPanel elevation={2} defaultExpanded className={classes.panel}>
        <ExpansionPanelSummary className={classes.panelSummary} expandIcon={<ExpandMoreIcon/>}>
          <FormSectionDescription title="Long text"/>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.extendedDetails}>
          <Field component={TextField}
            className={classes.textField}
            multiline
            variant="outlined"
            name={`universalConsentItemTranslations[${index}].longText`}
            label="Long text"/>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
};

export default withStyles(styles)(LanguageFields);
